export enum GrokModel {
	Grok3 = 'grok-3-latest',
	Grok4 = 'grok-4-0709',
}